var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buy" },
    [
      _c("div", { staticClass: "buy-top" }, [
        _c("div", { staticClass: "text-box" }, [
          _c(
            "p",
            {
              class: _vm.detail.code === "CASE_SOURCE_LOCK_TIME" && "only-one"
            },
            [_vm._v(_vm._s(_vm.detail.name))]
          ),
          _vm.detail.code === "CASE_SOURCE_LOCK_COUNT"
            ? _c("p", [_vm._v("单次可锁定" + _vm._s(_vm.hour) + "小时")])
            : _vm._e()
        ])
      ]),
      _c(
        "van-cell-group",
        { staticClass: "buy-member buy-member-bold" },
        [
          _c("van-cell", {
            attrs: { title: "订单价格" },
            scopedSlots: _vm._u([
              {
                key: "right-icon",
                fn: function() {
                  return [
                    _c("span", { staticClass: "members-price" }, [
                      _vm._v("￥" + _vm._s(_vm.detail.discountsPrice))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "van-cell-group",
        { staticClass: "buy-member", attrs: { border: false } },
        [
          _c("van-cell", {
            attrs: { title: "订单价格" },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function() {
                  return [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/imgs/members/wx.png"),
                        alt: "微信"
                      }
                    }),
                    _c("span", { staticClass: "custom-title" }, [
                      _vm._v("微信支付")
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "right-icon",
                fn: function() {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectPay("payWx")
                          }
                        }
                      },
                      [
                        _vm.payWx
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/services/buy-checked.png"),
                                alt: "选中"
                              }
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/services/uncheck.png"),
                                alt: "未选中"
                              }
                            })
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c("van-cell", {
            attrs: { title: "会员金额" },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function() {
                  return [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/imgs/members/wallet.png"),
                        alt: "微信"
                      }
                    }),
                    _c("span", { staticClass: "custom-title" }, [
                      _vm._v("钱包余额支付")
                    ]),
                    _c("label", [_vm._v("(" + _vm._s(_vm.myWallet) + "元)")])
                  ]
                },
                proxy: true
              },
              {
                key: "right-icon",
                fn: function() {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectPay("payWallet")
                          }
                        }
                      },
                      [
                        _vm.payWallet
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/services/buy-checked.png"),
                                alt: "选中"
                              }
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/services/uncheck.png"),
                                alt: "未选中"
                              }
                            })
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c("div", { staticClass: "flex service" }, [
        _c("div", { on: { click: _vm.selectService } }, [
          _vm.isAgree
            ? _c("img", {
                attrs: {
                  src: require("@/assets/imgs/members/xz.png"),
                  alt: "未选中"
                }
              })
            : _c("img", {
                attrs: {
                  src: require("@/assets/imgs/members/uncheck.png"),
                  alt: "选中"
                }
              })
        ]),
        _c("span", [
          _vm._v("支付即代表同意 "),
          _c("a", { attrs: { href: _vm.proUrl } }, [
            _vm._v("《增值服务购买协议》")
          ])
        ])
      ]),
      _vm.type === "buy_times"
        ? _c(
            "div",
            { staticClass: "count-down" },
            [
              _vm._v(" 请在"),
              _c("CountDown", { attrs: { time: _vm.lockTime } }),
              _vm._v("内完成支付，否则案源将释放 ")
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "footer tc" }, [
        _c("button", { on: { click: _vm.submit } }, [_vm._v("立即支付")])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }